import { endpoints } from 'Constants';

const financialServices = {
	balance: (params) => ({
		baseURL: endpoints.FINANCIAL.BALANCE(params),
		method: 'GET',
	}),
	balance_details: (params) => ({
		baseURL: endpoints.FINANCIAL.BALANCE_DETAILS(params),
		method: 'GET',
	}),
	verify_payment: (params) => ({
		baseURL: endpoints.FINANCIAL.VERIFY_PAYMENT(params),
		method: 'GET',
	}),
	payment_request: (params) => ({
		baseURL: endpoints.FINANCIAL.PAYMENT_REQUEST(params),
		method: 'POST',
	}),
	payment_history_list: (params) => ({
		baseURL: endpoints.FINANCIAL.PAYMENT_HISTORY_LIST(params),
		method: 'GET',
		params: params.params,
	}),

	payment_request_details: (params) => ({
		baseURL: endpoints.FINANCIAL.PAYMENT_REQUEST_DETAILS(params),
		method: 'GET',
	}),

	transactions: (params) => ({
		baseURL: endpoints.FINANCIAL.TRANSACTIONS(params),
		method: 'GET',
	}),
};

export default financialServices;
